"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addToCartCartCreator = void 0;
var util_1 = require("./util");
var addToCartCartCreator = function (event) {
    return (0, util_1.addToCartCartEvent)(event);
};
exports.addToCartCartCreator = addToCartCartCreator;
